/* eslint-disable import/prefer-default-export */
import makeAjaxRequest from 'helpers/makeAjaxRequest';
import { FETCH_INSTITUTION_AFFLIATIONS } from '../types';

const root = `${process.env.REACT_APP_ORIGIN}site-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/sites/number`;

export const fetchInstitutionAffliation = ctepId => async dispatch => {
  dispatch({
    type: FETCH_INSTITUTION_AFFLIATIONS,
    payload: makeAjaxRequest.fetchWithAuth(`${root}/${ctepId}/affiliation/details`).then(response => {
      const { data: responseData, ...responseRest } = response;
      if (Array.isArray(responseData) && responseData.length > 0) {
        const modifiedData = responseData.map((item, index) => ({ ...item, id: index }));
        return { data: modifiedData, ...responseRest };
      }
      return response
    })
  });
};
